var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertDanger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    className: "svg-icon svg-icon-error _33qeuNah2 _2pp5CNah2 _36JaO gyJp8 _32ydY",
    width: "22px",
    height: "22px",
    "aria-hidden": "true",
    "data-flx-comp": "ErrorIcon",
    "data-flx-version": "7.3.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51 14.936L2.915 10.34c-.78-.782-.78-2.048 0-2.83L7.51 2.916c.782-.78 2.048-.78 2.83 0l4.595 4.596c.78.782.78 2.048 0 2.83l-4.596 4.596c-.782.78-2.048.78-2.83 0zm4.243 1.414l4.596-4.596c1.56-1.562 1.56-4.095 0-5.657L11.752 1.5C10.19-.06 7.658-.06 6.096 1.5L1.5 6.098c-1.562 1.562-1.562 4.095 0 5.657l4.596 4.596c1.562 1.562 4.095 1.562 5.657 0z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9c0 .552.444 1 1 1 .552 0 1-.444 1-1V6c0-.552-.444-1-1-1-.552 0-1 .444-1 1v3zm1 4c.552 0 1-.444 1-1 0-.552-.444-1-1-1-.552 0-1 .444-1 1 0 .552.444 1 1 1z",
    fill: "#c00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDanger);
export default __webpack_public_path__ + "static/media/alert-danger.c7d953947bc2cb841b52ee81a0cb1c7e.svg";
export { ForwardRef as ReactComponent };